export default "__VITE_ASSET__yyqeVgI4__ 1458w";